/**
 * VidBolt.ai - Contact form submission.
 *
 * Submits in the background rather than letting the browser navigate to the
 * form provider. A provider outage then shows an inline message instead of
 * dropping the visitor on a third-party error page.
 */
'use strict';

document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('contact-form');
    const statusEl = document.getElementById('form-status');
    const button = document.getElementById('contact-submit-btn');
    if (!form || !statusEl || !button) return;

    const label = button.querySelector('.btn-label');
    const KEY_PLACEHOLDER = 'WEB3FORMS_ACCESS_KEY';

    function setStatus(kind, message) {
        statusEl.className = 'form-status is-' + kind;
        statusEl.textContent = message;
    }

    function setBusy(busy) {
        button.disabled = busy;
        if (label) label.textContent = busy ? 'Sending...' : 'Send Message';
    }

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const data = new FormData(form);

        // Guard against shipping with an unconfigured key, which would
        // otherwise fail in a way that looks like a user error.
        if (data.get('access_key') === KEY_PLACEHOLDER) {
            setStatus('error', 'The contact form is not configured yet. Please try again shortly.');
            return;
        }

        setBusy(true);
        setStatus('pending', 'Sending your message...');

        try {
            const res = await fetch(form.action, {
                method: 'POST',
                headers: { Accept: 'application/json' },
                body: data,
            });

            let payload = {};
            try {
                payload = await res.json();
            } catch (_) {
                // Provider returned a non-JSON body (e.g. an HTML error page).
            }

            if (res.ok && payload.success) {
                form.reset();
                setStatus('success', 'Thanks — your message is on its way. We usually reply within one business day.');
            } else {
                setStatus('error', payload.message || 'Something went wrong on our end. Please try again in a few minutes.');
            }
        } catch (_) {
            setStatus('error', 'We could not reach the server. Check your connection and try again.');
        } finally {
            setBusy(false);
        }
    });
});
